module.exports = __webpack_public_path__ + "static/media/hero-image-bg.8efacbde.svg";